import * as React from "react";
import { SVGProps } from "react";
const SvgLock = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25 12h-2v-2c0-3.9-3.1-7-7-7s-7 3.1-7 7v2H7c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V14c0-1.1-.9-2-2-2Zm-14-2c0-2.8 2.2-5 5-5s5 2.2 5 5v2H11v-2Zm14 17H7V14h18v13Zm-8-9v5h-2v-5h2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLock;
